import React from 'react';
import { X } from 'lucide-react';
import { getShortcutGroups } from '../../utils/appShortcuts.js';

const KeyboardShortcutsHelp = ({ open, onClose, user, pathname, extraGroups = [] }) => {
  if (!open) return null;
  const groups = [...getShortcutGroups({ user, pathname }), ...extraGroups];

  return (
    <div
      className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center p-3 sm:p-6 bg-black/40"
      data-app-modal="true"
      data-shortcuts-help="true"
      role="dialog"
      aria-modal="true"
      aria-labelledby="keyboard-shortcuts-title"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg max-h-[85vh] overflow-y-auto bg-white rounded-xl shadow-lg border border-gray-100 p-4 sm:p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 mb-3">
          <div>
            <h2 id="keyboard-shortcuts-title" className="text-base sm:text-lg font-semibold text-secondary">
              Keyboard shortcuts
            </h2>
            <p className="text-xs text-gray-500 mt-0.5">
              Same keys on Windows, macOS, and Linux. Only actions you can use are listed.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700"
            aria-label="Close shortcuts"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="space-y-4">
          {groups.map((group) => (
            <section key={group.id}>
              <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-1.5">
                {group.title}
              </h3>
              <ul className="divide-y divide-gray-50 border border-gray-100 rounded-xl overflow-hidden">
                {group.items.map((item) => (
                  <li
                    key={`${group.id}-${item.keys}`}
                    className="flex items-center justify-between gap-3 px-3 py-2 bg-white"
                  >
                    <span className="text-xs sm:text-sm text-gray-700">{item.action}</span>
                    <kbd className="shrink-0 px-1.5 py-0.5 rounded-md border border-gray-200 bg-gray-50 text-[11px] font-mono text-gray-800">
                      {item.keys}
                    </kbd>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyboardShortcutsHelp;
